/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionQuestionWording } from './oralExamSessionQuestionWording';
import type { OralExamSessionQuestionStartedAt } from './oralExamSessionQuestionStartedAt';
import type { OralExamSessionQuestionEndedAt } from './oralExamSessionQuestionEndedAt';
import type { OralExamSessionQuestionTranscriptHtml } from './oralExamSessionQuestionTranscriptHtml';

/**
 * Joined oral exam question: seal wording/clocks + optional transcript chapter.
 */
export interface OralExamSessionQuestion {
  id: string;
  wording?: OralExamSessionQuestionWording;
  startedAt?: OralExamSessionQuestionStartedAt;
  endedAt?: OralExamSessionQuestionEndedAt;
  transcriptHtml?: OralExamSessionQuestionTranscriptHtml;
}
